import GoogleMapPointAdater from '../../src/adapters/GoogleMapPointAdapter'

export default GoogleMapPointAdater
